import { FC } from "react";
import { Route, Switch } from "react-router-dom";

import { Enterprise as Content, useTranslation } from "@ctra/i18n";

import { DataDictionaryContext, DialogPageWrapper } from "@base";
import { Routes } from "@routes";
import { useFarm } from "@farms";

import { GACategories, SavedChartsContext } from "@analytics";

import { MetricSelectorPage, ConfigPage } from "..";

import styles from "./AnalyticsPage.module.less";
import { DashboardPage } from "../DashboardPage";
import { GAContext } from "@ctra/analytics";

/**
 * Analytics route page
 * @constructor
 */
const AnalyticsPage: FC = () => {
  const { t } = useTranslation();
  const { farm } = useFarm();

  const {
    analytics: {
      config: { pageTitle },
      v3
    }
  } = Content;

  return (
    <DataDictionaryContext.Provider>
      <SavedChartsContext.Provider farmID={farm?.id}>
        <section className={styles.PageContent}>
          <Switch>
            <Route exact path={Routes.app.analytics.configure.index}>
              <DialogPageWrapper title={t(v3.pageTitle)}>
                <GAContext.Provider value={{ category: GACategories.metricSelector }}>
                  <MetricSelectorPage />
                </GAContext.Provider>
              </DialogPageWrapper>
            </Route>
            <Route exact path={Routes.app.analytics.configure.metric}>
              <DialogPageWrapper title={t(pageTitle)}>
                <GAContext.Provider value={{ category: GACategories.configurator }}>
                  <ConfigPage />
                </GAContext.Provider>
              </DialogPageWrapper>
            </Route>
            <Route path={Routes.app.analytics.index}>
              <GAContext.Provider value={{ category: GACategories.dashboards }}>
                <DashboardPage />
              </GAContext.Provider>
            </Route>
          </Switch>
        </section>
      </SavedChartsContext.Provider>
    </DataDictionaryContext.Provider>
  );
};

export default AnalyticsPage;
